import React, { Component } from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { List } from 'immutable'
import SelectList from 'components/common/SelectList'
import {
  fetchActiveBarriosList,
  setActiveBarrios,
} from 'reducers/seaLice/reducer'
import messages from 'components/Apps/SeaLiceMonitor/translate'
import ifWindowWidthLessThan from 'helpers/ifWindowWidthLessThan'

class BarriosFilter extends Component {
  componentDidMount() {
    this.props.fetchActiveBarriosList()
  }

  onBarriosChange = v => {
    if (v) {
      this.props.setActiveBarrios(v.index)
    }
  }

  render() {
    if (ifWindowWidthLessThan(992)) return null

    const {
      intl: { formatMessage },
      activeBarrios,
      barriosList,
    } = this.props
    const barrios = [
      {
        id: 0,
        name: formatMessage(messages.allBarrios),
      },
      ...barriosList.toArray(),
    ]

    return (
      <div className="caption-panel">
        <SelectList
          label={formatMessage(messages.barrios)}
          className="sealice-table-select"
          name="barrios"
          onChange={this.onBarriosChange}
          list={List(barrios)}
          value={+activeBarrios}
          map={{
            index: 'id',
            text: 'name',
          }}
        />
      </div>
    )
  }
}

export default connect(
  state => ({
    barriosList: state.getIn(['seaLice', 'barriosList']),
    activeBarrios: state.getIn(['seaLice', 'activeBarrios']),
  }),
  {
    fetchActiveBarriosList,
    setActiveBarrios,
  },
)(injectIntl(BarriosFilter))
